
import React from 'react';
import { SignalHigh, SignalZero } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface BikeIoTStatusProps {
  online?: boolean;
}

export const BikeIoTStatus: React.FC<BikeIoTStatusProps> = ({ online }) => {
  return (
    <Badge variant="outline" className={`flex items-center gap-1 ${online ? 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800/40' : 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800/40'}`}>
      {online ? (
        <>
          <SignalHigh className="h-3 w-3 text-green-500 dark:text-green-400" />
          <span>IoT Online</span>
        </>
      ) : (
        <>
          <SignalZero className="h-3 w-3 text-red-500 dark:text-red-400" />
          <span>IoT Offline</span>
        </>
      )}
    </Badge>
  );
};
